import { useTranslation } from 'next-i18next';
import { useEffect, useState } from 'react';

import { MUTED_GRAY, NOPING_GREEN } from '../constants';

export function LiveCounter() {
  const { t } = useTranslation('components/trial/lp/v1c');
  const [online, setOnline] = useState(47832);

  useEffect(() => {
    const interval = setInterval(() => {
      setOnline((prev) => prev + Math.floor(Math.random() * 7) - 2);
    }, 3000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className='inline-flex items-center gap-2 rounded-full px-4 py-2' style={{ background: `${NOPING_GREEN}0D`, border: `1px solid ${NOPING_GREEN}26` }}>
      <span className='relative flex size-2.5'>
        <span className='absolute inline-flex size-full animate-ping rounded-full opacity-75' style={{ background: NOPING_GREEN }} />
        <span className='relative inline-flex size-2.5 rounded-full' style={{ background: NOPING_GREEN }} />
      </span>
      <span className='font-mono text-sm font-medium tabular-nums' style={{ color: NOPING_GREEN }}>
        {online.toLocaleString()}
      </span>
      <span className='text-xs' style={{ color: MUTED_GRAY }}>
        {t('live_counter.online_now')}
      </span>
    </div>
  );
}
